import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Chart from 'react-apexcharts'
import { Card } from 'components/Library'
import { colors } from 'components/Library/theme'

const ViewsPerLanguage = () => {
  const { pageAnalytics } = useSelector((state) => state.analytics)
  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    if (pageAnalytics[2] && pageAnalytics[2].rowCount > 0) {
      const datos = []
      pageAnalytics[2].rows.forEach((analytic) => {
        // Obtener los valores de la iteración actual
        const idioma = analytic.dimensionValues[1].value // idioma
        const valor = analytic.metricValues[0].value // screenPageViews

        console.log('idioma :>> ', idioma)

        const index = datos.findIndex((dato) => dato.idioma?.toUpperCase() === idioma?.toUpperCase())
        if (index !== -1) {
          datos[index].valor += parseInt(valor)
        }

        if (index === -1) {
          datos.push({
            idioma: idioma === '(not set)' ? 'Otro' : idioma?.toUpperCase(),
            valor: parseInt(valor)
          })
        }
      })
      datos.sort((a, b) => a.valor - b.valor)

      setDatosGrafico(datos)
    }
  }, [pageAnalytics])

  return (
    <Card style={{ padding: '2rem', width: '100%' }}>
      <Chart
        options={{
          labels: datosGrafico.map((item) => item.idioma),
          title: {
            text: 'Idioma de navegación'
          },
          colors: [colors.primary, colors.secondary, colors.tertiary]
        }}
        series={datosGrafico.map((item) => item.valor)}
        type="pie"
      />
    </Card>
  )
}

export default ViewsPerLanguage
